<template>
    <div>
        <div class="form-group">
            <label class="col-md-2 control-label">Discovery Method</label>
            <div class="col-md-10" style="padding-left:20px">
                <div class="row well">
                    <div v-for="discovery in discoveryMethodSelectedList" class="col-md-3 checkbox checkbox-inline">
                        <input readonly type="checkbox" v-model="discovery.discoveryMethodId">
                        <label>{{discovery.description}}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">Work Performed</label>
            <div class="col-md-10" style="padding-left:20px">
                <div class="row well">
                    <div v-for="workType in workTypeSelectedList" class="col-md-3 checkbox checkbox-inline">
                        <input readonly type="checkbox" v-model="workType.investigativeWorkTypeId">
                        <label>{{workType.description}}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">Collections</label>
            <div class="col-md-5" style="padding-left:20px">
                <label><span>Were materials collected as part of this recording</span></label>
                <div class="form-control"> {{materialsCollectedLabel}} </div>
            </div>
            <div class="col-md-5" style="padding-left:20px" v-show="investigativeHistory.materialsCollectedId == 1">
                <label><span>Repository</span></label>
                <div class="form-control"> {{repositoryLabel}} </div>
                <div  style="padding-top:10px" v-show="investigativeHistory.repositoryId == 3">
                    <div class="form-control"> {{investigativeHistory.otherRepository}} </div>
                </div>
            </div>
        </div>
        <div v-show="isDebug">
            {{investigativeHistory}}
        </div>
    </div>
</template>

<script>
import loggingService from '../../services/util/loggingService'
import investigativeHistoryService from '../../services/siteForm/investigativeHistoryService'

export default {
    name: 'investigativeHistoryForm',
    components: {
    },
    props: ['crrId'],
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            discoveryMethodSelectedList: [],
            workTypeSelectedList: [],
            investigativeHistory: {}
        }
    },
    computed: {
        materialsCollectedLabel: function () {
            switch (this.investigativeHistory.materialsCollectedId) {
            case 1:
                return 'Yes'
            case 2:
                return 'No'
            default:
                return 'Unknown'
            }
        },
        repositoryLabel: function () {
            switch (this.investigativeHistory.repositoryId) {
            case 1:
                return 'U.W. Archaeological Repository'
            case 2:
                return 'Western Wyoming College'
            default:
                return 'Other'
            }
        }
    },
    mounted () {
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'InvestigativeHistoryForm', message)
        },

        loadDiscoveryMethods () {
            this.log('load discovery methods')
            var searchDto = {investigativeHistoryId: this.investigativeHistory.investigativeHistoryId}
            return investigativeHistoryService.searchDiscoveryMethod(this.$http, searchDto).then(result => {
                this.discoveryMethodSelectedList = investigativeHistoryService.getDiscoveryMethodList().filter(discovery => {
                    return result.data.some(x => x.discoveryMethodId === discovery.discoveryMethodId)
                })
            })
        },
        loadInvestigativeWorks () {
            this.log('load investigative works for investigative History ID ' + this.investigativeHistory.investigativeHistoryId)
            var searchDto = {investigativeHistoryId: this.investigativeHistory.investigativeHistoryId}
            return investigativeHistoryService.searchInvestigativeWork(this.$http, searchDto).then(result => {
                this.log('found investigative works, count: ' + result.data.length)
                this.workTypeSelectedList = investigativeHistoryService.getInvestigativeWorkTypeList().filter(workType => {
                    return result.data.some(x => x.investigativeWorkTypeId === workType.investigativeWorkTypeId)
                })
                return result
            })
        },
        loadData () {
            this.log('Loading Data for crrId: ' + this.crrId)
            return investigativeHistoryService.searchInvestigativeHistory(this.$http, {culturalResourceRecordingId: this.crrId}).then(response => {
                if (response.data.length > 0) {
                    this.log('found one response')
                    this.investigativeHistory = response.data[0]
                    this.log('enrolled:' + this.investigativeHistory.investigativeHistoryId)
                    Promise.all([
                        this.loadDiscoveryMethods(),
                        this.loadInvestigativeWorks()
                    ]).then(response2 => {
                        this.log('done loading others')
                        return response2
                    })
                } else {
                    this.log('no response found')
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// InvestigativeHistory.vue?a0881b0a